import { createAsyncThunk } from "@reduxjs/toolkit";
import { API, API_URL } from "../../../config/api";
import axiosService from "../../../services/axiosServicesVisit";

const api_url = API_URL + API.PRODUCTS.GETPRODUCTS;

export const getProducts = createAsyncThunk(
  'products/getProducts',
  async ({ page = 1, limit = 10, filter }, thunkAPI) => {
    try {
      const { search, price } = filter;
      let searchQuery = '';
      let priceQuery = '';

      if (price && price.length > 0) {
        priceQuery = `price=${encodeURIComponent(price)}`;
      }

      if (search && search.length > 0) {
        searchQuery = `name=${encodeURIComponent(search)}`;
      }

      const queryString = [searchQuery, priceQuery].filter((item) => item.length > 0).join('&');

      const response = await axiosService.get(`${api_url}?page=${page}&limit=${limit}&${queryString}`);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || 'An error occurred');
    }
  }
);


export const addProduct = createAsyncThunk(
  "products/addProduct",
  async (productsData, thunkAPI) => {
    try {
      const response = await axiosService.post(api_url, productsData);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const deleteProduct = createAsyncThunk(
  "products/deleteProduct",
  async (id, thunkAPI) => {
    try {
      const response = await axiosService.delete(`${api_url}/${id}`);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const updateProduct = createAsyncThunk(
  "products/updateProduct",
  async ({ id, productsData }, thunkAPI) => {
    try {
      const response = await axiosService.patch(`${api_url}/${id}`, productsData);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const getProductByID = createAsyncThunk(
  "products/getProductByID",
  async (id, thunkAPI) => {
    try {
      const response = await axiosService.get(`${api_url}/${id}`);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const importProducts = createAsyncThunk(
  "products/importProducts",
  async (data, thunkAPI) => {
    try {
      const response = await axiosService.post(`${api_url}/import?format=csv`, data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);